import dayjs, { Dayjs } from 'dayjs';

export const isCurrentTimeInGivenRange = (
  startDate: Dayjs,
  endDate: Dayjs,
  timezone?: string,
) => {
  return dayjs().tz().isBetween(startDate, endDate, 'millisecond');
};
